module.exports = __webpack_public_path__ + "static/media/tg.ab2a68f4.svg";